import { customAlphabet } from 'nanoid/non-secure'
import { alphanumeric } from 'nanoid-dictionary'

const generateId = customAlphabet(alphanumeric, 8)

export default generateId
